import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import React from "react";

interface TipProps {
  text: string;                          // Tooltip text
  placement?: "top" | "bottom" | "left" | "right";
  delayShow?: number;                    // Delay before showing tooltip
  delayHide?: number;                    // Delay before hiding tooltip
  disabled?: boolean;                    // Allow disabling tooltip
  children: React.ReactElement;          // Must be exactly 1 child
  className?: string;                    // Optional wrapper classes
}

const Tip: React.FC<TipProps> = ({
  text,
  placement = "top",
  delayShow = 200,
  delayHide = 150,
  disabled = false,
  children,
  className = "",
}) => {
  if (disabled || !text) {
    // Tooltip disabled → return child without OverlayTrigger
    return React.cloneElement(children, {
      className: `${children.props.className || ""} ${className}`,
    });
  }

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: delayShow, hide: delayHide }}
      overlay={<Tooltip>{text}</Tooltip>}
    >
      {/* Clone child so additional props can be added safely */}
      {React.cloneElement(children, {
        className: `${children.props.className || ""} ${className}`,
      })}
    </OverlayTrigger>
  );
};

export default Tip;
